export default "__VITE_ASSET__BNUc_j12__"